/**
 * Entry: main.jsx
 * Initializes Firebase first, then mounts the React app with global styles.
 * Uses React 18 root API and StrictMode during development.
 */
// Import Firebase initialization first, before any other imports
import './firebase/firebase'; // Ensure Firebase is initialized first

// Then import other dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Render the app immediately - React will handle the placeholder removal properly
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
